import { isEqual } from "lodash";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { switchWorkspaceForEntityLink } from "slices/app/actions/app";
import { selectIsLoggedIn, selectUserWorkspaceId } from "slices/app/selectors";
import { resolveEntityLink } from "utils/entityLinks";

const useEntityWorkspaceResolution = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const isLoggedIn = useSelector(selectIsLoggedIn);
  const workspaceId = useSelector(selectUserWorkspaceId);

  const targetHash = `#${location.pathname}${location.search}`;
  const entityLink = resolveEntityLink(targetHash);
  const resolvedEntityRef = useRef(null);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    if (isEqual(entityLink, resolvedEntityRef.current)) {
      return;
    }
    resolvedEntityRef.current = entityLink;

    if (!entityLink) {
      return;
    }

    dispatch(switchWorkspaceForEntityLink(targetHash, workspaceId));
  }, [targetHash, isLoggedIn, workspaceId, entityLink]);
};

export default useEntityWorkspaceResolution;
